<template>
  <div class="w-full h-full flex flex-col py-12px justify-start">
    <div class="items flex gap-[3%] flex-wrap">
      <div v-for="item in resourceList" :key="item.id" class=" w-[30%] h-[150px]  cursor-pointer"
        @click="handleClick(item)">
        <div
          class="template-card w-[100%] h-[100%] overflow-hidden border border-solid border-[#e5e5e5] rounded-md flex items-center justify-center"
          style="border-radius: 10px;">
          <img :src="item.full_preview_url" alt="" class="w-[100%]  rounded">
          <div class="caption">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <div v-if="resourceList.length === 0">
      <el-empty description="暂无数据" />
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ElInput, ElButton, ElIcon, ElDropdown, ElDropdownMenu, ElDropdownItem, ElMessageBox, ElMessage, ElEmpty } from 'element-plus'
import { Folder, Search, Filter, FolderRemove, FolderOpened, Plus, ArrowLeft } from '@element-plus/icons-vue'
import { ref, computed, onMounted, watch } from 'vue'
import { getResourceList } from '@/api/affairs'
const props = defineProps({
  id: {
    type: Number,
    default: 0
  }
})
watch(() => props.id, (newVal, oldVal) => {
  if (newVal != oldVal) {
    getList()
  }
})
onMounted(() => {
  getList()

})
const resourceList = ref([])
const getList = () => {
  getResourceList({
    pageNum: 1, pageSize: 30, file_type: 1, folder_id: props.id
  }).then(res => {
    resourceList.value = res.data.data.items
  })
}

const handleClick = (item: any) => {
  window.open(`/editor?id=${item.id}&mode=user`)
}

</script>

<style lang="scss" scoped>
.template-card {
  position: relative;
}

.caption {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 24px;
  line-height: 24px;
  font-size: 12px;
  color: #fff;
  text-align: center;
  background: rgba(0, 0, 0, 0.45);
  opacity: 0;
  transition: opacity .2s ease;
}

.template-card:hover .caption {
  opacity: 1;
}
</style>
